// src/features/companies/components/CompanyForm.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../hooks/useAuth';

const CompanyForm = ({ company, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({
        nit: '',
        nombre: '',
        direccion: '',
        telefono: '',
        contacto: '',
        email: '',
        telefono_secundario: '',
        contacto_secundario: '',
        email_secundario: '',
        telefono_terciario: '',
        contacto_terciario: '',
        email_terciario: '',
        cantidad_horas: '',
	    valor_hora: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { isManager } = useAuth();
    // Si estamos editando, cargar los datos de la empresa
    useEffect(() => {
        if (company) {
            setFormData({
                nit: company.nit || '',
                nombre: company.nombre || '',
                direccion: company.direccion || '',
                telefono: company.telefono || '',
                contacto: company.contacto || '',
                email: company.email || '',
                telefono_secundario: company.telefono_secundario || '',
                contacto_secundario: company.contacto_secundario || '',
                email_secundario: company.email_secundario || '',
                telefono_terciario: company.telefono_terciario || '',
                contacto_terciario: company.contacto_terciario || '',
                email_terciario: company.email_terciario || '',
                cantidad_horas: company.cantidad_horas || '',
	            valor_hora: company.valor_hora || '',
            });
        }
    }, [company]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await onSubmit(formData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4 max-h-96 overflow-y-auto">
            {error && (
                <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded">
                    {error}
                </div>
            )}

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                    <label htmlFor="nit" className="block text-sm font-medium text-gray-700">
                        NIT *
                    </label>
                    <input
                        type="text"
                        id="nit"
                        name="nit"
                        required
                        value={formData.nit}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        placeholder="Ej: 901.163.080-7"
                        disabled={!!company} // No permitir cambiar NIT al editar
                    />
                </div>

                <div>
                    <label htmlFor="nombre" className="block text-sm font-medium text-gray-700">
                        Nombre *
                    </label>
                    <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        required
                        value={formData.nombre}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                    <label htmlFor="cantidad_horas" className="block text-sm font-medium text-gray-700">
                        Cantidad de Horas *
                    </label>
                    <input
                        type="number"
                        id="cantidad_horas"
                        name="cantidad_horas"
                        required
                        value={formData.cantidad_horas}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                </div>
                { isManager &&
                <div>
                    <label htmlFor="valor_hora" className="block text-sm font-medium text-gray-700">
                        Valor Hora *
                    </label>
                    <input
                        type="number"
                        id="valor_hora"
                        name="valor_hora"
                        required
                        value={formData.valor_hora}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                </div>
                }
            </div>

            <div>
                <label htmlFor="direccion" className="block text-sm font-medium text-gray-700">
                    Dirección *
                </label>
                <input
                    type="text"
                    id="direccion"
                    name="direccion"
                    required
                    value={formData.direccion}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                    <label htmlFor="telefono" className="block text-sm font-medium text-gray-700">
                        Teléfono *
                    </label>
                    <input
                        type="text"
                        id="telefono"
                        name="telefono"
                        required
                        value={formData.telefono}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                </div>

                <div>
                    <label htmlFor="contacto" className="block text-sm font-medium text-gray-700">
                        Contacto *
                    </label>
                    <input
                        type="text"
                        id="contacto"
                        name="contacto"
                        required
                        value={formData.contacto}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                </div>
            </div>

            <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email *
                </label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
            </div>

            {/* Campos secundarios */}
            <div className="border-t pt-4">
                <h4 className="text-md font-medium text-gray-900 mb-3">Información de Contacto Secundaria</h4>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                        <label htmlFor="telefono_secundario" className="block text-sm font-medium text-gray-700">
                            Teléfono Secundario
                        </label>
                        <input
                            type="text"
                            id="telefono_secundario"
                            name="telefono_secundario"
                            value={formData.telefono_secundario}
                            onChange={handleChange}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        />
                    </div>

                    <div>
                        <label htmlFor="contacto_secundario" className="block text-sm font-medium text-gray-700">
                            Contacto Secundario
                        </label>
                        <input
                            type="text"
                            id="contacto_secundario"
                            name="contacto_secundario"
                            value={formData.contacto_secundario}
                            onChange={handleChange}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        />
                    </div>
                </div>

                <div className="mt-4">
                    <label htmlFor="email_secundario" className="block text-sm font-medium text-gray-700">
                        Email Secundario
                    </label>
                    <input
                        type="email"
                        id="email_secundario"
                        name="email_secundario"
                        value={formData.email_secundario}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                </div>
            </div>

            {/* Campos terciarios */}
            <div className="border-t pt-4">
                <h4 className="text-md font-medium text-gray-900 mb-3">Información de Contacto Terciaria</h4>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                        <label htmlFor="telefono_terciario" className="block text-sm font-medium text-gray-700">
                            Teléfono Terciario
                        </label>
                        <input
                            type="text"
                            id="telefono_terciario"
                            name="telefono_terciario"
                            value={formData.telefono_terciario}
                            onChange={handleChange}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        />
                    </div>

                    <div>
                        <label htmlFor="contacto_terciario" className="block text-sm font-medium text-gray-700">
                            Contacto Terciario
                        </label>
                        <input
                            type="text"
                            id="contacto_terciario"
                            name="contacto_terciario"
                            value={formData.contacto_terciario}
                            onChange={handleChange}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        />
                    </div>
                </div>

                <div className="mt-4">
                    <label htmlFor="email_terciario" className="block text-sm font-medium text-gray-700">
                        Email Terciario
                    </label>
                    <input
                        type="email"
                        id="email_terciario"
                        name="email_terciario"
                        value={formData.email_terciario}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                </div>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
                <button
                    type="button"
                    onClick={onCancel}
                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    disabled={loading}
                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
                >
                    {loading ? 'Guardando...' : (company ? 'Actualizar' : 'Crear Empresa')}
                </button>
            </div>
        </form>
    );
};

export default CompanyForm;